<template lang="html">
  <div class="slide">
    <svg ref="scene" class="canvas" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" :viewBox="`0 0 ${canvasWidth} ${canvasHeight}`">
      <clipPath id="clipBoxes" ref="clipBoxes">
        <rect x="196" y="135" width="449" height="72" />
        <rect x="560" y="211" width="203" height="45" />
        <rect x="606" y="256" width="192" height="39" />
        <rect x="582" y="314" width="192" height="48" />
        <rect x="656" y="362" width="172" height="39" />
      </clipPath>
      <rect ref="frame" id="Frame" x="0" y="0" :width="canvasWidth" :height="canvasHeight" />
      <clipPath id="clip-frame">
        <use xlink:href="#Frame"/>
      </clipPath>
      <g clip-path="url(#clip-frame)">
        <g ref="layers" :transform-origin="`${canvasWidth/2} ${canvasHeight/2}`">
          <g transform="translate(0) scale(0.24 0.24)">
            <foreignObject x="0" y="0" :width="4175" :height="3006">
              <picture>
                <source :srcset="`${publicPath}scenes/classroom/Classroom1-480w.jpg`" media="(max-width: 480px)">
                <source :srcset="`${publicPath}scenes/classroom/Classroom1-768w.jpg`" media="(max-width: 768px)">
                <source :srcset="`${publicPath}scenes/classroom/Classroom1-1280w.jpg`" media="(max-width: 1280px)">
                <source :srcset="`${publicPath}scenes/classroom/Classroom1-1920w.jpg`" media="(max-width: 1920px)">
                <img :style="{width: `100%`, height: `auto`}" :src="`${publicPath}scenes/classroom/Classroom1.jpg`" />
              </picture>
            </foreignObject>
          </g>
          <g clip-path="url(#clipBoxes)">
            <image width="624.91" height="264.91" x="203.64" y="133.65" :xlink:href="`${publicPath}scenes/classroom/Classroom2.png`"/>
          </g>
          <g class="arm" ref="arm">
            <g transform="translate(305.7 76.89)">
            <ImageLazy
              width="114.49" height="331.5"
              :srcs="[
                `${publicPath}scenes/classroom/Classroom3-q80-w200.png`,
                `${publicPath}scenes/classroom/Classroom3.png`
              ]"/>
            </g>
          </g>
        </g>
      </g>
    </svg>
    <SceneDialogue
      ref="dialogue"
      :width="0.33" :tx="0" :ty="0.66">
      Max’s father, Grandpa Jim, and his neighbor were involved in a dispute
      about a property line near Shonto. Grandpa Jim decided that he wanted
      someone he could trust to help with the matter, who could speak both
      English and fluent Navajo, if it was going to be settled in U.S. court.
      So, Max started school in 1911.
    </SceneDialogue>
    <SceneAudio ref="scene-audio" :src="`${publicPath}scenes/classroom/audio-charlie-navajo.mp3`" />
  </div>
</template>

<script>
import { TimelineLite, TweenMax } from "gsap"
import SceneDialogue from "../SceneDialogue.vue"
import SceneAudio from "../SceneAudio.vue"
import Template from "./Template"

export default {
  extends: Template,
  data: () => ({
    publicPath: process.env.BASE_URL,
    canvasWidth: 1000,
    canvasHeight: 720,
    tl: null,
  }),
  mounted() {
    const {layers, arm, dialogue, clipBoxes} = this.$refs
    const boxes = clipBoxes.querySelectorAll("rect")
    const d = dialogue.$el

    // this.tl = new TimelineLite({paused: true, onComplete: this.audioPlay})
    TweenMax.set(layers, {
      transformOrigin: `${this.canvasWidth/2}px ${this.canvasHeight/2}px`,
      opacity: 0, scale: 1.5,
    })
    TweenMax.set(d, {opacity: 0})
    this.tl.add(TweenMax.to(layers, 3, {scale: 1, opacity: 1}))
    this.tl.add(TweenMax.to(arm, 0.5, { rotate: "12deg", transformOrigin: "99% 90%" }), 3)
    this.tl.add(TweenMax.to(arm, 0.5, { rotate: "0deg", transformOrigin: "99% 90%"  }), 3.5)

    this.tl.add(TweenMax.staggerFromTo(boxes, 1,
      { x: function() {
        return -parseFloat(this._targets[0].getAttribute("width")) } },
      { x: 0 }, 0.5), 2)

    this.tl.add(TweenMax.to(d, 0.5, {opacity: 1}))
  },
  methods: {
    enter() {
      this.tl.play()
    },
  },
  props: ["slide"],
  components: {
    SceneDialogue,
    SceneAudio,
  },
}
</script>
